import axios from 'axios';

/**
 * Instance Axios de base, configurée pour toutes les requêtes API.
 * Elle inclut l'URL de base et la gestion des cookies.
 */
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
  timeout: 30000,
});

/**
 * Intercepteur de requête - Ajoute automatiquement le token à chaque requête
 * C'est CRUCIAL pour maintenir la session après un refresh de page
 */
apiClient.interceptors.request.use(
  (config) => {
    // Récupérer le token depuis localStorage à chaque requête
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Intercepteur de réponse - Gère les erreurs d'authentification
 */
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Si erreur 401 et pas déjà en train de retry
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Essayer de rafraîchir le token
      try {
        const refreshResponse = await axios.post(
          `${apiClient.defaults.baseURL}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        
        if (refreshResponse.data?.token) {
          // Sauvegarder le nouveau token
          localStorage.setItem('token', refreshResponse.data.token);
          
          // Mettre à jour le header et relancer la requête
          originalRequest.headers.Authorization = `Bearer ${refreshResponse.data.token}`;
          return apiClient(originalRequest);
        }
      } catch (refreshError) {
        // Le refresh a échoué, déconnecter l'utilisateur
        console.log('[ApiClient] Refresh token échoué, déconnexion...');
        localStorage.removeItem('token');
        localStorage.removeItem('isAdminSession');
        
        // Émettre un événement pour que AuthContext puisse réagir
        window.dispatchEvent(new CustomEvent('authSessionExpired', { 
          detail: { reason: 'refresh_failed' } 
        }));
        
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient; 